<template>
<v-form ref="f" lazy-validation v-model="valid">
	<v-container v-if="hotels.length">
		<v-row >
			<v-col class="pt-6 mt-1 pb-0" cols="12" sm="6" >
				<span class="headline">Чеки и гости службы питания</span>
			</v-col>
			<v-col class="pb-0" cols="12" sm="6" >
				<a-hotel-select v-model="hotelCode"
						  	 :hotels="hotels"
						  	 :loading="hotelLoading"
						  	 @change="getValues">
				</a-hotel-select>
			</v-col>
		</v-row>
		<v-row >
			<v-col cols="4" sm="2" class="text-center pb-0">
				<span class="subtitle-1"></span>
			</v-col>
			<v-col cols="8" sm="4" class="text-center pb-0">
				<span class="subtitle-1">Чеки</span>
			</v-col>
			<v-col cols="4" sm="1" class="text-center pb-0">
			</v-col>
			<v-col cols="8" sm="4" class="text-center pb-0">
				<span class="subtitle-1">Гости</span>
			</v-col>
		</v-row>
		<v-row >
			<v-col class="pt-0" cols="4" sm="2" >
			</v-col>
			<v-col cols="4" sm="2" class="text-center">
				<span class="subtitle-1">{{ lastMonthFormat }}</span>
			</v-col>
			<v-col cols="4" sm="2" class="text-center">
				<span class="subtitle-1">{{ monthFormat }}</span>
			</v-col>
			<v-col sm="1" class="text-center" v-if="$vuetify.breakpoint.smAndUp">
			</v-col>
			<v-col sm="2" class="text-center" v-if="$vuetify.breakpoint.smAndUp">
				<span class="subtitle-1">{{ lastMonthFormat }}</span>
			</v-col>
			<v-col sm="2" class="text-center" v-if="$vuetify.breakpoint.smAndUp">
				<span class="subtitle-1">{{ monthFormat }}</span>
			</v-col>
		</v-row>

		<template v-for="(line, key) in form">
			<v-row v-if="line.name || outlets[key]" :key="key">
				<v-col class="py-2" cols="4" sm="2" >

					<v-tooltip right max-width="500" v-if="line.tooltip">
						<template v-slot:activator="{ on }">
							<span class="subtitle-1" v-on="on">{{ line.name ? line.name : outlets[key] }} </span><span class="red--text">*</span>
						</template>
						<span>{{ line.tooltip }}</span>
					</v-tooltip>
					<span class="subtitle-1" v-else>{{ line.name ? line.name : outlets[key] }}</span>
				</v-col>
				<v-col class="py-0" cols="4" sm="2" >
					<a-number-field v-model="line.checks.value[0]"
								:loading="valuesLoading"
								class="my-0 py-0"
								digits=0
								readonly>
					</a-number-field>
				</v-col>
				<v-col class="py-0" cols="4" sm="2" >
					<a-number-field v-model="line.checks.value[1]"
								:loading="valuesLoading"
								class="my-0 py-0"
								@input.native="dataChanged = true"
								digits=0>
					</a-number-field>
				</v-col>
				<v-col class="py-0" sm="1" v-if="$vuetify.breakpoint.smAndUp">
				</v-col>
				<v-col class="py-0" cols="4" sm="2" >
					<a-number-field v-model="line.guests.value[0]"
								:loading="valuesLoading"
								class="my-0 py-0"
								readonly
									digits=0>
					</a-number-field>
				</v-col>
				<v-col class="py-0" cols="4" sm="2" >
					<a-number-field v-model="line.guests.value[1]"
								:loading="valuesLoading"
								class="my-0 py-0"
								@input.native="dataChanged = true"
								digits=0>
					</a-number-field>
				</v-col>
			</v-row>
		</template>
		<v-row>
			<v-col class="py-0" cols="4" sm="2" >
				<div class="mt-4">
					<span class="subtitle-1">Итого</span>
				</div>
			</v-col>
			<v-col class="py-0" cols="4" sm="2" >
				<a-number-field v-model="total.checks[0]"
							 readonly
							 prepend-icon="functions"
							 :loading="valuesLoading"
							 digits=0>
				</a-number-field>
			</v-col>
			<v-col class="py-0" cols="4" sm="2" >
				<a-number-field v-model="total.checks[1]"
							 readonly
							 prepend-icon="functions"
							 :loading="valuesLoading"
							 digits=0>
				</a-number-field>
			</v-col>
			<v-col class="py-0" sm="1" v-if="$vuetify.breakpoint.smAndUp">
			</v-col>
			<v-col class="py-0" cols="4" sm="2" >
				<a-number-field v-model="total.guests[0]"
							 readonly
							 prepend-icon="functions"
							 :loading="valuesLoading"
							 digits=0>
				</a-number-field>
			</v-col>
			<v-col class="py-0" cols="4" sm="2" >
				<a-number-field v-model="total.guests[1]"
							 readonly
							 prepend-icon="functions"
							 :loading="valuesLoading"
							 digits=0>
				</a-number-field>
			</v-col>
		</v-row>

		<v-row >
			<v-col class="pb-0 pt-0" cols="12" >
				<v-btn color="primary"
					   class="ml-0"
					   :disabled="!dataChanged"
					   @click="validate">
					Сохранить
				</v-btn>
			</v-col>
		</v-row>
	</v-container>
	<v-container v-else>
		<v-row>
			<v-col>
				<p class="subtitle-1">
					Нет доступных P&L отчетов
				</p>
			</v-col>
		</v-row>
	</v-container>
	<v-dialog	v-model="dialogConfirm.show"
			  	persistent
  			  	max-width="600">
		<v-card>
	  		<v-card-title class="headline">
				Подтверждение
			</v-card-title>
	        <v-card-text>

				<v-row>
					<v-col cols="12" >
						<span v-html="dialogConfirm.html" class="text--primary"></span>
					</v-col>
					<v-col cols="12" class="mb-4">
						<span class="text--primary">Вы уверены, что ввели коректные данные?</span>
					</v-col>
				</v-row>

				<v-btn class="mr-2" color="primary" @click="send">
					Да
				</v-btn>
				<v-btn class="mx-2" color="secondary" @click="dialogConfirm.show = false">
					Назад
				</v-btn>
	        </v-card-text>
      	</v-card>
	</v-dialog>
</v-form>
</template>

<script>
	import _ from 'lodash'
	import aNumberField from '../../base/ANumberField.vue'
	import aHotelSelect from '../../base/AHotelSelect.vue'
	import {api} from '../../../lib/api'
	import {getMonthName, toNum, toStr} from '../../../js/common.js'

	export default {
		components: {
			aNumberField,
			aHotelSelect
		},
		data: () => ({
			valid: false,
			dataChanged: false,
			hotelCode: '',
			form: {
				breakfast: {
					name: 'Breakfast',
					checks: {
						code: 1330,
						value: ['0', '0']
					},
					guests: {
						code: 1230,
						value: ['0', '0']
					}
				},
				rest1: {
					name: '',
					checks: {
						code: 1310,
						value: [0, 0]
					},
					guests: {
						code: 1210,
						value: [0, 0]
					}
				},
				rest2: {
					name: '',
					checks: {
						code: 1311,
						value: [0, 0]
					},
					guests: {
						code: 1211,
						value: [0, 0]
					}
				},
				rest3: {
					name: '',
					checks: {
						code: 1312,
						value: [0, 0]
					},
					guests: {
						code: 1212,
						value: [0, 0]
					}
				},
				rest4: {
					name: '',
					checks: {
						code: 1313,
						value: [0, 0]
					},
					guests: {
						code: 1213,
						value: [0, 0]
					}
				},
				rest5: {
					name: '',
					checks: {
						code: 1314,
						value: [0, 0]
					},
					guests: {
						code: 1214,
						value: [0, 0]
					}
				},
				lobby: {
					name: '',
					checks: {
						code: 1320,
						value: [0, 0]
					},
					guests: {
						code: 1220,
						value: [0, 0]
					}
				},
				lounge: {
					name: '',
					checks: {
						code: 1340,
						value: [0, 0]
					},
					guests: {
						code: 1240,
						value: [0, 0]
					}
				},
				rs: {
					name: 'Rooms Service',
					checks: {
						code: 1370,
						value: [0, 0]
					},
					guests: {
						code: 1270,
						value: [0, 0]
					}
				},
				mb: {
					name: 'Minibar',
					checks: {
						code: 1380,
						value: [0, 0]
					},
					guests: {
						code: 1280,
						value: [0, 0]
					}
				},
				bq: {
					name: 'Banqueting',
					checks: {
						code: 1360,
						value: [0, 0]
					},
					guests: {
						code: 1260,
						value: [0, 0]
					}
				},
				comp: {
					name: 'Complimentary',
					tooltip: 'Под комплиментарными чеками понимаются любые чеки со 100% скидкой - питание дежурных менеджеров, представительские расходы и т.п. Данные чеки не участвуют в подсчете значений среднего чека, но участвуют в подсчете расходов F&B per Guest',
					checks: {
						code: 1300,
						value: [0, 0]
					},
					guests: {
						code: 1200,
						value: [0, 0]
					}
				},
			},
			dc: 50,
			hotels: null,
			valuesLoading: false,
			hotelLoading: false,
			outletLoading: false,
			dialogConfirm: {
				show: false,
				html: ''
			}
		}),
		computed: {
			outlets() {
				return (this.selectedHotel && this.selectedHotel.outlets) ? this.selectedHotel.outlets : {
					rest1: '',
					rest2: '',
					rest3: '',
					rest4: '',
					rest5: '',
					lobby: '',
					lounge: ''
				}
			},
			total() {
				let c = [0, 0]
				let g = [0, 0]
				for (let line in this.form) {
					if (this.form[line].checks) {
						c[0] += toNum(this.form[line].checks.value[0])
						c[1] += toNum(this.form[line].checks.value[1])
					}
					if (this.form[line].guests) {
						g[0] += toNum(this.form[line].guests.value[0])
						g[1] += toNum(this.form[line].guests.value[1])
					}
				}
				c[0] = toStr(c[0], 0)
				c[1] = toStr(c[1], 0)
				g[0] = toStr(g[0], 0)
				g[1] = toStr(g[1], 0)

				return {
					checks: c,
					guests: g
				}
			},
			selectedHotel() {
				let index = this.hotels.map(hotel => (hotel.code || null)).indexOf(this.hotelCode)
				return this.hotels[index]
			},
			month() {
				if (this.selectedHotel && this.selectedHotel.month) return this.selectedHotel.month
				else return undefined
			},
			monthFormat() {
				if (this.month) return getMonthName(this.month.substr(5, 2), 'Ul')
				else return undefined
			},
			lastMonthFormat() {
				if (!this.month) return undefined
				let d = this.month.substr(5, 2) - 1
				if (d == 0) d = 12
				return getMonthName(d, 'Ul')
			}
		},
		created() {
			if (this.$store.getters.userHo) {
				this.hotels = this.$store.getters.allHotels
			}
			else {
				this.hotels = this.$store.getters.userHotels
			}

			this.hotelCode = this.$store.getters.selectedHotelCode || this.hotels[0].code
			// this.hotelCode = 'TEST'

			this.apiFirstCall()
		},
		methods: {
			validate() {
				if (!this.$refs.f.validate()) return

				let notices = [];

				for (let line in this.form) {
					let g = toNum(this.form[line].guests.value[1])
					let c = toNum(this.form[line].checks.value[1])

					if (g == 0 && c == 0) continue

					let avGpT = (g / c).toFixed(2)
					let outletName = this.form[line].name ? this.form[line].name : this.outlets[line]

					if (avGpT < 1 || avGpT > 5) {
						notices.push('Соотношение гостей к чекам по аутлету ' + outletName +
							': ' + avGpT + '. Гостей: ' + g + ', чеков: ' + c)
					}
				}

				if (notices.length) {
					this.dialogConfirm.show = true
					this.dialogConfirm.html = '<p>' + notices.join('</p><p>') + '</p>'
				}
				else {
					this.send()
				}
			},
			send() {
				this.dialogConfirm.show = false
				this.$store.dispatch('dialogLoadingStart')

				api.post('pl/set_hod_data', {
					form: this.trimmedForm(),
					hotelCode: this.hotelCode,
					month: this.selectedHotel.month,
					dc: this.dc,
					readyDept: 'fb'
				})
				.then(response => {

					this.$store.dispatch('dialogLoadingStop')
					this.$store.dispatch('dialogDone')
					this.dataChanged = false

				}, error => {})
			},
			apiFirstCall() {
				this.hotelLoading = true
				this.outletLoading = true
				api.all([
					api.post('pl/get_pending_report_month', { hotels: this.hotels }),
					api.post('common/get_hotel_outlets', { hotels: this.hotels })
				])
				.then(api.spread((responseM, responseO) => {
					this.hotelLoading = false
					this.outletLoading = false

					this.hotels = responseM.data.hotels
					this.hotels = this.hotels.filter(hotel => !!hotel.month)

					if (this.hotels.length == 0) return

					this.hotels.forEach((hotel, key) => {
						hotel.outlets = responseO.data.hotels[key].outlets
					})

					this.hotelCode = this.$store.getters.selectedHotelCode || this.hotels[0].code
					// this.hotelCode = 'TEST'
					this.getValues()

				}), error => {})
			},
			getValues(hotelCode) {
				this.valuesLoading = true

				// if (!hotelCode) hotelCode = this.hotelCode
				// let index = this.hotels.map(hotel => (hotel.code || null)).indexOf(hotelCode)
				// let selectedHotel = this.hotels[index]
				// let month = selectedHotel.month

				api.post('pl/get_hod_data', {
					form: this.trimmedForm(),
					hotelCode: this.hotelCode,
					month: this.selectedHotel.month,
					dc: this.dc,
				})
				.then(response => {
					this.valuesLoading = false

					for (let line in this.form) {
						if (this.form[line].checks) {
							this.form[line].checks.value = response.data.form[line].checks.value
						}
						if (this.form[line].guests) {
							this.form[line].guests.value = response.data.form[line].guests.value
						}
					}
					this.$refs.f.resetValidation()
					this.dataChanged = false

				}, error => {})
			},
			trimmedForm() {
				let newForm = _.cloneDeep(this.form)

				for (let line in newForm) {
					for (let prop in newForm[line]) {
						if (prop != 'guests' && prop != 'checks') {
							delete newForm[line][prop]
						}
					}
				}

				return newForm
			}
		}
	}
</script>
